import { styled } from '@mui/system';
import { Typography, Box, Grid2, Switch } from '@mui/material';

export const TypographyStyledHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.primaryDark,
  fontSize: '1.625rem',
  width: '100%',
  textAlign: 'center',
  fontWeight: 450,
  paddingTop: '1.25rem',
  fontFamily: 'BGBold',
  lineHeight: '1.875rem'
}));

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});

export const BMRSection = styled(Grid2)(({ theme }) => ({
  background: theme.palette.common.white,
  margin: '1.875rem',
  borderRadius: '0.9375rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  width: '90%',
  height: '57px',
  padding: '0.9375rem'
}));

export const BMRTitle = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontWeight: 450,
  color: theme.palette.primaryDark,
  fontFamily: 'BGBold'
}));

export const BMRValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.875rem',
  fontWeight: 700,
  lineHeight: '35px',
  fontFamily: 'Calibri',
  color: theme.palette.lightBlue
}));

export const SwitchStyled = styled(Switch)(({ theme }) => ({
  width: '70px',
  height: '1.75rem',
  borderRadius: '100px',
  fontFamily: 'BGBold',
  padding: 0,
  '& .Mui-checked': {
    transform: 'translateX(2.5rem) !important',
    color: `${theme.palette.common.white} !important`
  },
  '& .Mui-checked+.MuiSwitch-track': {
    backgroundColor: `${theme.palette.primaryDark} !important`,
    opacity: '1 !important',
    '&::before': {
      content: '"YES"',
      left: 12,
      color: theme.palette.common.white
    },
    '&::after': {
      content: '""'
    }
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '40%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16
    },
    '&::after': {
      content: '"NO"',
      right: 17,
      color: theme.palette.common.white
    }
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 15,
    height: 15,
    margin: -2
  }
}));

export const SelectionTitleStyled = styled(Typography)(({ theme }) => ({
  width: '90%',
  fontWeight: 400,
  color: theme.palette.primaryDark,
  fontFamily: 'Calibri',
  lineHeight: '1.25rem',
  fontSize: '1rem'
}));

export const SelectionBoxStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0.9375rem 0',
  gap: '60px'
});
